'use client';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TiTick } from 'react-icons/ti';
import { motion } from 'framer-motion';

// Note: Ensure your environment has these dependencies installed:
// npm install framer-motion react-router-dom react-icons

const imageAnim = {
  hidden: { opacity: 0, x: -60, scale: 0.97 },
  show: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: { duration: 0.5, ease: 'easeOut' },
  },
};

const fadeInRight = {
  hidden: { opacity: 0, x: 60 },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut',
      staggerChildren: 0.1,
    },
  },
};

const fadeInItem = {
  hidden: { opacity: 0, y: 10 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, ease: 'easeOut' },
  },
};

const AboutUs = () => {
  const navigate = useNavigate();

  // Placeholder image URL - replace with your local asset path as needed
  const leftImg = "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=800";

  return (
    <section className="py-16 px-4 bg-white" id="about">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">

          {/* Left Image */}
          <motion.div
            className="relative"
            variants={imageAnim}
            initial="hidden"
            whileInView="show"
            viewport={{ once: false, amount: 0.4 }}
          >
            <motion.img
              src={leftImg}
              alt="About us"
              className="w-full h-full object-cover rounded-lg shadow-md"
              whileHover={{ scale: 1.02 }}
              transition={{ type: 'spring', stiffness: 100 }}
              onError={(e) => { e.target.src = 'https://via.placeholder.com/800x600?text=About+Us'; }}
            />
          </motion.div>

          {/* Right Text */}
          <motion.div
            className="space-y-6"
            variants={fadeInRight}
            initial="hidden"
            whileInView="show"
            viewport={{ once: false, amount: 0.4 }}
          >
            {/* Title Block */}
            <motion.div variants={fadeInItem}>
              <p className="text-[#f7941d] font-semibold text-sm uppercase tracking-wide mb-2">
                Few Words About Us
              </p>

              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight">
                Software Development{' '}
                <span className="text-gray-800">Company</span>
              </h2>

              <div className="w-16 h-1 bg-[#f7941d] mt-4"></div>
            </motion.div>

            {/* Paragraphs with updated content */}
            <motion.div className="space-y-4" variants={fadeInItem}>
              <p className="text-gray-600 text-lg leading-relaxed">
                BytesFarms Technologies, a trusted Software Development Company, 
                offers 20+ years of team expertise. We optimize operations, 
                enhance customer engagement, and drive growth for customers
                with our wealth of industry experience.
              </p>
              <p className="text-gray-600 text-lg leading-relaxed">
                Our expert team understands clients' business challenges. 
                We collaborate closely to craft tailored solutions that drive 
                measurable results. Thriving in today's competitive marketplace 
                is our clients' ultimate goal.
              </p>
            </motion.div>

          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default AboutUs;